module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form class=\"add-bank\"> <a class=\"add_account btn btn-lg btn-default btn-block\" href=\"#\"> <span class=\"bank-img\"></span> Add Bank Account </a> </form> <p class=\"note\">Recommended for reliability and stability purposes. Declined/expired credit cards often prevent purchases.</p> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/bank_account_button.ejs
// module id = 864
// module chunks = 1